// extracted by mini-css-extract-plugin
export default {"container":"history_container__OETip","spin":"history_spin__zrSb5","header":"history_header__f8tU7","title":"history_title__j0zbq","content":"history_content__a8ijZ"};